/**
 * @(#)2019/8/20.
 * YxPopconfirm，气泡确认框
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxPopconfirm from "./YxPopconfirm";
import PropTypes from "prop-types";
YxPopconfirm.propTypes = {
  //是否需要弹出确认框
  isConfirm: PropTypes.bool,

  //是否显示
  visible: PropTypes.bool,

  //确认回调
  onConfirm: PropTypes.func,

  //取消回调
  onCancel: PropTypes.func,
};

YxPopconfirm.defaultProps = {};

export default YxPopconfirm;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxPopconfirm/index.js